import commerceConfig from '@commerce/config'
import { Breadcrumbs, Error, Layout, Loader, SeoHead } from '@components/common'
import { Share } from '@components/icons'
import { Container, useUI } from '@components/ui'
import WYSIWYG from '@components/ui/WYSIWYG'
import getGlobalStaticProps from '@lib/globalStaticProps'
import { SliceZone } from '@prismicio/react'
import { components } from '@slices/index'
import type {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { createClient, getDocByUid } from 'prismicio'
type Path = {
  params: {
    slug: string
  }
  locale: string
}
export async function getStaticProps({
  params,
  locale,
  previewData,
}: GetStaticPropsContext<{ slug: string }>) {
  const path = params?.slug
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)
  const translations = await serverSideTranslations(locale ?? 'en-au', [
    'common',
  ])
  let page = null
  try {
    const fetchLinks = [
      'article.name',
      'article.title',
      'article.blogCategory',
      'article.thumbnail',
    ]
    page = await getDocByUid('article', path!, client, locale, fetchLinks)
  } catch (err) {
    console.log(err)
  }

  if (!page) {
    return { notFound: true }
  }

  return {
    props: {
      ...globalProps,
      ...translations,
      page,
    },
    // revalidate: 200,
  }
}

export async function getStaticPaths({ locales }: GetStaticPathsContext) {
  if (process.env.VERCEL_ENV === 'preview') {
    return {
      paths: [],
      fallback: true,
    }
  }
  const {
    config: { defaultLocale },
  } = commerceConfig

  // const pages = await queryAll(
  //   {
  //     query: GET_ALL_ARTICLE_PAGES_FOR_FEED,
  //     variables: { lang: defaultLocale },
  //   },
  //   'allArticles'
  // )

  // const paths = pages
  //   .map((page) => {
  //     const uid = page?.node?._meta?.uid
  //     const slugs = uid.split('.')?.filter((s?: string) => s && s !== '')
  //     return slugs?.map((slug: string) => {
  //       return locales?.map((locale) => {
  //         return { params: { slug }, locale }
  //       })
  //     })
  //   })
  //   .flat(2)

  return {
    paths: [],
    fallback: true,
  }
}
export default function Slug({
  page,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  const { t, i18n } = useTranslation('common')

  const { data }: any = page || {}
  let firstCrum = { label: t('the-alchemist'), link: '/the-alchemist' }
  let secondCrum = {
    label: `${data?.blogCategory}`,
    link: `/articles/${data?.blogCategory.replace(/\s+/g, '').toLowerCase()}`,
  }

  const crumbs = [
    firstCrum,
    secondCrum,
    {
      label: data?.name,
      link: router.asPath,
    },
  ]
  const { setSidebarView, openSidebar } = useUI()
  if (router.isFallback) return <Loader title="product-loader" />

  if (!data) {
    return <Error code={404} />
  }

  const articleTitle = data?.title
  const articleTitleRichText = data?.richTextTitle
  const articleName = data?.name
  const { seoImage, seoDescription, seoTitle } = data || {}
  const handleShareClick = () => {
    setSidebarView('SHARE_ARTICLE_SIDEBAR_VIEW')
    openSidebar()
  }
  const handleMobileShareClick = () => {
    setSidebarView('SHARE_ARTICLE_SIDEBAR_MOBILE_VIEW')
    openSidebar()
  }
  return (
    <>
      <SeoHead
        title={seoTitle || articleName}
        description={seoDescription || articleTitle}
        image={seoImage}
      />
      <div className="flex flex-col gap-8 bg-ui-light-grey pb-10 lg:gap-20 lg:pb-20">
        <Container className="py-2 md:pt-6 md:pb-4">
          <Breadcrumbs crumbs={crumbs} lastCrumH1 />
        </Container>
        <div className="wrapper flex flex-col justify-between gap-4 lg:flex-row lg:gap-0">
          {articleTitleRichText && (
            <h1 className="lg:heading-3 heading-mobile-3 w-full lg:w-[864px] ">
              <WYSIWYG content={articleTitleRichText} />
            </h1>
          )}
          <div
            onClick={handleShareClick}
            className="hidden cursor-pointer items-center gap-3 hover:opacity-75 lg:flex"
          >
            <div className="body-1 ">{t('share-this-story')}</div>
            <Share />
          </div>
          <button
            onClick={handleMobileShareClick}
            className="flex cursor-pointer items-center gap-3 hover:opacity-75 lg:hidden"
          >
            <div className="body-1 ">{t('share-this-story')}</div>
            <Share />
          </button>
        </div>
      </div>
      <SliceZone slices={data?.slices} components={components} />
    </>
  )
}

Slug.Layout = Layout
